import {feedbackRef, feedbackReportRef, usersRef} from "../../config/firebaseConfig";
import {getAll} from "./firebaseHelpers";
import {range, userName} from "../index";
import {getThisDateAtGmt8} from "../timeHelpers";

Array.prototype.sum = function () {
    return this.reduce((acc, cur) => acc + cur, 0)
}

Array.prototype.avg = function () {
    return this.sum() / this.length
}

export async function getFeedbackReport() {
    const report = await feedbackReportRef.doc('report').get().then(sn => sn.data())
    return report || await generateAndUpdateFeedbackReport()
}

export async function generateAndUpdateFeedbackReport() {
    const report = await generateFeedbackReport()
    console.log(report)
    await feedbackReportRef.doc('report').set(report)
    return report;
}

export async function generateFeedbackReport() {
    const users = await getAll(usersRef)
    const usersMap = users.reduce((obj, cur) => ({...obj, [cur.CustID]: cur}), {});
    const feedbacks = await getAll(feedbackRef)

    return {
        summary: range(1, 7).map(i => {
                const k = `question${i}`
                return {
                    number: i,
                    question: feedbacks[0][k].question,
                    answers: i < 5 ?
                        getNumStats(feedbacks, k) :
                        getTextStats(usersMap, feedbacks, k)
                }
            }),
        allFeedbacks: feedbacks
            .filter(notEmptyFeedback)
            .map(getFeedbackObject(usersMap))
    }
}

function notEmptyFeedback(feedback){
    return range(1, 7).some(notEmptyAnswer(feedback))
}

function notEmptyAnswer(feedback){
    return questionIndex => {
        const ans = feedback[`question${questionIndex}`].answer
        return questionIndex < 5 ? ans !== "0" : ans !== ""
    }
}

function getFeedbackObject(usersMap){
    return (feedback) => {
        const initalObj = {
            user: userName(usersMap[feedback.userId]),
            time: getThisDateAtGmt8(new Date(feedback.timestamp)).toLocaleTimeString()
        }

        return range(1, 7)
            .filter(notEmptyAnswer(feedback))
            .map(ind => `question${ind}`)
            .reduce(
                (obj, curQ) => ({
                    ...obj,
                    [curQ]: feedback[curQ]
                }), initalObj)
    }
}

function getNumStats(feedbacks, qKey) {
    return feedbacks
        .map(f => f[qKey].answer)
        .filter(_ => _ !== "0")
        .avg()
}

function getTextStats(usersMap, feedbacks, qKey) {
    return feedbacks
        .filter(f => f[qKey].answer)
        .map(f => ({
            answer: f[qKey].answer,
            user: userName(usersMap[f.userId]),
            userId: f.userId
        }))
}

